import React, { useState } from "react";
import ErrorMessage from "components/error-message";
import { useCart } from "hooks/useStore";
import { ReactComponent as Tag } from "assets/svgs/tag.svg";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import clsx from "clsx/lite";

const DiscountTags = () => {
	const { updateDiscountCodes, discountCodes } = useCart(["updateDiscountCodes", "discountCodes"]);

	const handleRemoveDiscount = (codeToRemove) => {
		const filteredCodes = discountCodes.filter(({ code }) => code !== codeToRemove).map(({ code }) => code);
		updateDiscountCodes(filteredCodes);
	};

	return (
		<div className="absolute z-10 left-1.5 top-[5px] flex flex-wrap gap-1">
			{discountCodes.map(({ code, applicable }) =>
				applicable ?
					<div key={code} className="text-sm bg-beige bg-opacity-40 py-1.5 px-2 rounded-md flex gap-1 items-center uppercase">
						<Tag />
						{code}
						<button onClick={() => handleRemoveDiscount(code)} type="button">
							<Close className="size-2.5 ml-2 mr-1 stroke-black stroke-[4]" />
						</button>
					</div>
					: null
			)}
		</div>
	);
};

const DiscountInput = () => {
	const [discountCode, setDiscountCode] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const { updateDiscountCodes, discountCodes } = useCart(["updateDiscountCodes", "discountCodes"]);

	const hasApplicableDiscount = discountCodes?.some(({ applicable }) => applicable);
	const isDisabled = hasApplicableDiscount || loading;

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		const resp = await updateDiscountCodes([discountCode]);
		const discountError = resp?.discountCodes.some(
			({ code, applicable }) => code === discountCode && !applicable
		);

		if (discountError) {
			setError("Discount code not applicable");
			setTimeout(() => setError(null), 3000);
		}

		setDiscountCode("");
		setLoading(false);
	};

	return (
		<>
			<form onSubmit={handleSubmit} className="relative">
				<input
					type="text"
					id="discount"
					name="discount"
					disabled={isDisabled}
					placeholder={!hasApplicableDiscount ? "Enter Discount Code" : ""}
					value={discountCode}
					onChange={(e) => setDiscountCode(e.target.value)}
					className={clsx(
						"border focus:outline-beige p-2 w-full pl-4 border-beige placeholder-darkGray",
						"disabled:opacity-50 disabled:cursor-not-allowed placeholder:text-sm",
						{ "border-opacity-100": discountCode, "border-opacity-30": !discountCode }
					)}
				/>
				{hasApplicableDiscount && <DiscountTags />}
				<button
					type="submit"
					disabled={isDisabled}
					className="btn-primary px-3.5 h-[30px] absolute right-1.5 top-1/2 transform -translate-y-1/2 text-xs font-normal"
				>
					Apply
				</button>
			</form>
			{error && <ErrorMessage message={error} className="text-xs" />}
		</>
	);
};

export default DiscountInput;
